import React from 'react';
import styles from './fieldError.module.scss';
import clsx from 'clsx';

interface FieldErrorProps {
  message?: string;
  className?: string;
}

const ErrorMessage: React.FC<FieldErrorProps> = ({ message, className }) => {
  const inputError = clsx(className, {
    [styles.FieldError]: !className,
  });
  return <div className={inputError}>{message}</div>;
};

export default ErrorMessage;
